module.exports = __webpack_public_path__ + "img/trackinghint@2x.d38121f2.png";